/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersUserLightDto } from '../../models/users-user-light-dto';

export interface UsersControllerFindLightByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Exclude soft-deleted users. Set to "false" to include them. Default: true
 */
  excludeDeleted?: string;
}

export function usersControllerFindLightByTenant(http: HttpClient, rootUrl: string, params: UsersControllerFindLightByTenant$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersUserLightDto>>> {
  const rb = new UsersRequestBuilder(rootUrl, usersControllerFindLightByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('excludeDeleted', params.excludeDeleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<Array<UsersUserLightDto>>;
    })
  );
}

usersControllerFindLightByTenant.PATH = '/o2-users/users/{tenant}/light';
